// Same GET request agar abhi in-flight hai to naya network call nahi hota,
// sabko wahi promise milta hai. (Double effect / double mount par 2 baar API call roakne ke liye)
const inflight = new Map();

export function dedupe(key, fn) {
  if (inflight.has(key)) return inflight.get(key);
  const p = Promise.resolve()
    .then(fn)
    .finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
}
